import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { userAppContext } from '@/context/Context';
import DownloadDump from './DownloadDump';

import SideBarLayout from '../Layout/SideBarLayout';
import ToolsSidebar from '../Tools/ToolsSidebar';

import RInstallation from '../Tools/RPackage/RInstallation';
import RDocumentation from '../Tools/RPackage/RDocumentation';

import HowTo from '../Tools/API/HowTo';

import CodeExamples from '../Tools/API/CodeExamples';
import InfoandSupport from '../Tools/API/InfoandSupport';
import ApiEndpoints from '../Tools/API/Endpoints';
import InteractiveConsole from '../Tools/API/InteractiveConsole';

import Installation from '../Tools/CytoscapeApp/Installation';

import Aida from '../Tools/DisgenetAI/Aida';
import BackgroundPages from '@/global/Background/BackgroundPages';

function APIContent() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const section = searchParams.get('section');

  const { user } = userAppContext();
  console.log(user['cognito:groups']);
  const userRole = user['cognito:groups'][0];
  const rolesAllowedDownloadDump = ['ROLE_UNLIMITED', 'ROLE_DEVELOPER'];

  // Redirigir si no hay sección ni versión
  useEffect(() => {
    const hasSection = searchParams.has('section');
    const hasVersion = searchParams.has('version');

    if (!hasSection && !hasVersion) {
      navigate(`${location.pathname}?section=Rinstallation`, { replace: true });
    }
  }, [searchParams, location.pathname, navigate]);

  return (
    <React.Fragment>
      <div className="apply-trial-page">
        <BackgroundPages />
        <section className="relative z-10 px-2 lg:px-14 md:mt-24 mt-20">
          <div className="flex flex-col lg:flex-row lg:gap-8 lg:p-14">
            {/* Sidebar */}
            <SideBarLayout>
              <ToolsSidebar onClick={null} collapsed={false} />
            </SideBarLayout>

            {/* Content */}
            <div className="w-full lg:w-3/4 lg:flex-grow">
              <div className="tab-content" id="dbInfoTabbedPane">
                <div className="space-y-6">
                  {section === 'Rinstallation' && <RInstallation />}
                  {section === 'Rdocumentation' && <RDocumentation />}
                  {section === 'console' && <InteractiveConsole />}
                  {section === 'howtouse' && <HowTo />}
                  {section === 'endpoints' && <ApiEndpoints />}
                  {section === 'examples' && <CodeExamples />}
                  {section === 'support' && <InfoandSupport />}
                  {section === 'installcyto' && <Installation />}
                  {section === 'download' && rolesAllowedDownloadDump.includes(userRole) && (
                    <div>
                      <h4>DISGENET download</h4>
                      <p>
                        Only users with a PREMIUM profile can download the files. For information on how to
                        obtain a DISGENET license, contact us at{' '}
                        <a href="mailto:info@disgenet.com">info@disgenet.com</a>. To download DISGENET, please
                        enter your api key. <br />
                        <br />
                        The database is provided as a collection of tsv or{' '}
                        <a href="https://parquet.apache.org/" target="_blank" rel="noopener noreferrer">
                          parquet
                        </a>{' '}
                        files.
                        <React.Fragment>
                          <DownloadDump />
                        </React.Fragment>
                      </p>
                      <p>Use this command for downloading the database from the command line: </p>
                      <pre className="dump_code">
                        <code>
                          {' '}
                          wget --output-document=disgenet_dump.gz --post-data 'api-key=API-KEY'
                          http://api.disgenet.com/dump/download
                        </code>
                      </pre>
                      <p>Use these commands to verify the database was downloaded correctly:</p>
                      <p>
                        <p>
                          <strong>Windows:</strong>
                        </p>
                        <pre className="dump_code">
                          <code>
                            <ol>
                              <li>
                                1. Download and install a utility that can generate MD5 hashes, such as{' '}
                                <a href="https://learn.microsoft.com/en-us/windows-server/administration/windows-commands/certutil">
                                  CertUtil
                                </a>
                                .
                              </li>
                              <li>2. Open Command Prompt.</li>
                              <li>
                                3. Navigate to the directory containing the .tar.gz file you want to check.
                              </li>
                              <li>4. Run the following command: CertUtil -hashfile yourfile.tar.gz MD5</li>
                              <li>5. Compare the output with the expected MD5 hash.</li>
                            </ol>
                          </code>
                        </pre>
                        <p>
                          <strong>macOS and Linux:</strong>
                        </p>
                        <pre className="dump_code">
                          <code>
                            <ol>
                              <li>1. Open Terminal.</li>
                              <li>
                                2. Navigate to the directory containing the .tar.gz file you want to check.
                              </li>
                              <li>
                                3. Run the following command: md5 yourfile.tar.gz (macOS) or md5sum
                                yourfile.tar.gz (Linux)
                              </li>
                              <li>4. Compare the output with the expected MD5 hash.</li>
                            </ol>
                          </code>
                        </pre>
                      </p>
                    </div>
                  )}
                  {section === 'assistant' && <Aida />}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </React.Fragment>
  );
}

export default APIContent;
